import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Achievements as Desk } from './desk'
import { Achievements as Mob } from './mob'

type Props = {
  images: TImages
}

export const Achievements: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return <Component images={images} />
}
